<template>
    <div>
        <header-vue></header-vue>
        <div style="height: 40px"></div>
        <div class="banner">
            <!-- <div>会社の概要</div> -->
            <el-row>
                <el-col :span="12">
                    <img src="@/assets/map.jpg" alt="ジャルダン田端ビル1F【地図】" width="500"><br>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <div class="map"></div>
                    <h3>
                        〒114-0012 東京都北区田端新町3丁目35-12
                    </h3>
                    <el-link href="https://maps.app.goo.gl/znfiVSCh1rL6vQDz8" target="_blank">ジャルダン田端ビル1F【地図】</el-link>
                </el-col>
            </el-row>
            <el-row>
                <div style="display: inline-block;">
                    <h3>BICマックス本店</h3>
                    〒114-0012 東京都北区田端新町3丁目35-12<br>
                    ジャルダン田端ビル1F<br>
                    TEL: <el-link href="tel:03-3894-0908" type="success"
                        style="font-weight:inherit; font-size:larger;">03-3894-0908</el-link><br>
                    営業時間: 10:00 〜 19:00 定休：日曜日<br>
                    運営会社：株式会社BIC・マックス<br>
                    会社設立日:2012年2月<br>
                    代表取締役:何 亮<br>
                    取引銀行:三菱UFG銀行　三井住友銀行　東日本銀行
                </div>
                <div>
                    <h3>事業内容</h3>
                    電化製品の買取・販売<br>
                    業者様・メーカー様・法人様大歓迎<br>
                    <h3>最寄り駅</h3>
                    JR田端駅北口から徒歩10分<br>
                </div>
                
                <div>
                    <img src="@/assets/abort_imgs/1.jpg" width="400px">
                    <img src="@/assets/abort_imgs/3.jpg" width="400px">
                    <img src="@/assets/abort_imgs/4.jpg" width="400px">
                    <img src="@/assets/abort_imgs/5.jpg" width="400px">
                    <img src="@/assets/abort_imgs/6_1.jpg" width="400px">
                    <img src="@/assets/abort_imgs/2.jpg" width="360px">
                </div>

            </el-row>
        </div>

        <FooterVue></FooterVue>
    </div>
</template>

<script>
import HeaderVue from "../components/Header.vue";
import FooterVue from "../components/FFooter.vue";
export default {
    components: { HeaderVue, FooterVue },
    props: {},
    data() {
        return {};
    },
    mounted() { },
    methods: {},
};
</script>
<style scoped>
.banner {
    width: 77vw;
    margin: 0px auto;
    padding: 20px 0;
    box-sizing: border-box;
    color: #555;
}
</style>